import { React, useContext, useState } from 'react'
import { FullScreen, useFullScreenHandle } from 'react-full-screen'
import { useEffect } from 'react'

import { SVGPDF } from '../../../../components/SVG/SVGPDF'
import styles from "../../styles.module.css"
import { api } from '../../../../services/api'
import { GravaLogB2B } from '../../../../pages/Login/functions/GravaLogB2B'
import MyContext from '../../../../contexts/myContext'

export function GridProdutosServicos(props) {
    const [isFullScreenProdutos, setIsFullScrennProdutos] = useState(false)
    const handleProdutosFullScreen = useFullScreenHandle()

    const [orderByProdutos, setOrderByProdutos] = useState('CodigoItem')
    const [ascDescProdutos, setAscDescProdutos] = useState(0)

    function setFullScreenProdutos() {
        if (isFullScreenProdutos) {
            handleProdutosFullScreen.exit()
            setIsFullScrennProdutos(false)
        } else {
            handleProdutosFullScreen.enter()
            setIsFullScrennProdutos(true)
        }
    }

    const [somaTotalLinha, setSomaTotalLinha] = useState(0)
    const [somaDesconto, setSomaDesconto] = useState(0)
    const [somaQtd, setSomaQtd] = useState(0)
    const [somaUnitario, setSomaUnitario] = useState(0)

    function getValorSomaRegistros() {
        let vsomaTotalLinha = 0
        let vsomaDesconto = 0
        let vsomaQtd = 0
        let vsomaUnitario = 0

        props.RegistrosProdutos
            .map(item => {
                vsomaTotalLinha += item.TotalLinha
                vsomaDesconto += item.DescontoItem
                vsomaQtd += item.Quantidade
                vsomaUnitario += item.PrecoUnitario
            })

        setSomaTotalLinha(vsomaTotalLinha)
        setSomaDesconto(vsomaDesconto)
        setSomaQtd(vsomaQtd)
        setSomaUnitario(vsomaUnitario)
    }

    useEffect(() => {
        getValorSomaRegistros()
    }, [props.RegistrosProdutos])

    const [isDownloadPDF, setIsDownloadPDF] = useState(false)

    const { user } = useContext(MyContext)

    const handleDownloadPDF = async () => {
        try {
            setIsDownloadPDF(true)
            // Enviando os dados JSON para o servidor
            const response = await api.get(`/api/gerarpdf/COTACAOCONTRATO/${props.CodigoRegistro}`, {
                headers: {
                    'Content-Type': 'application/json'
                },
                responseType: 'blob'
            });

            // Criando um URL temporário para o arquivo
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Criando um link e clicando nele para iniciar o download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `COTACAOCONTRATO_${props.CodigoRegistro}.pdf`);
            document.body.appendChild(link);
            link.click();
            await GravaLogB2B(`DOWNLOAD PDF - COTACAOCONTRATO_${props.CodigoRegistro}.pdf`, user.cnpj);
        } catch (error) {
            console.error('Erro ao baixar o arquivo:', error);
        }
        finally {
            setIsDownloadPDF(false)
        }
    };

    return (
        <div className={`h-full relative w-full  `} handle={handleProdutosFullScreen}>
            <div className='overflow-x-scroll max-h-[40vh] min-h-[40vh] ' >
                <table id="table-to-xls-produtos" className=" table-fixed w-full  border-separate">
                    <thead>
                        <tr className="border-b-2 text-sm sticky top-0 bg-gradient-to-r from-slate-200 to-slate-100">
                            <th className="w-24 pl-1 text-center cursor-pointer" onClick={() => {
                                setOrderByProdutos('CodigoProduto')
                                setAscDescProdutos(ascDescProdutos === 0 ? 1 : 0)
                            }}>Cód. Seq</th>
                            <th className="w-24 pl-1 text-center cursor-pointer" onClick={() => {
                                setOrderByProdutos('CodigoDeBarras')
                                setAscDescProdutos(ascDescProdutos === 0 ? 1 : 0)
                            }}>Cód. Interno</th>

                            <th className="w-40 text-left cursor-pointer" onClick={() => {
                                setOrderByProdutos('Descricao')
                                setAscDescProdutos(ascDescProdutos === 0 ? 1 : 0)
                            }}>Produto</th>
                            <th className="w-24 text-right cursor-pointer" onClick={() => {
                                setOrderByProdutos('PrecoUnitario')
                                setAscDescProdutos(ascDescProdutos === 0 ? 1 : 0)
                            }}>Unitário</th>

                            <th className="w-24 text-right cursor-pointer" onClick={() => {
                                setOrderByProdutos('Quantidade')
                                setAscDescProdutos(ascDescProdutos === 0 ? 1 : 0)
                            }}>Qtd.</th>
                            <th className="w-24 text-right cursor-pointer" onClick={() => {
                                setOrderByProdutos('DescontoItem')
                                setAscDescProdutos(ascDescProdutos === 0 ? 1 : 0)
                            }}>Desconto</th>
                            <th className="w-24 text-right cursor-pointer" onClick={() => {
                                setOrderByProdutos('TotalLinha')
                                setAscDescProdutos(ascDescProdutos === 0 ? 1 : 0)
                            }}>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.RegistrosProdutos?.length > 0
                            ? (
                                props.RegistrosProdutos?.sort((a, b) =>
                                    a[orderByProdutos] > b[orderByProdutos]
                                        ? ascDescProdutos === 0
                                            ? 1
                                            : -1
                                        : ascDescProdutos === 0
                                            ? -1
                                            : 1
                                ).map((item, key) => {

                                    return (
                                        <>
                                            <tr key={key} className="odd:bg-white-100 even:bg-gray-100 ">
                                                <td className="text-sm text-center truncate pl-1 ">{item.CodigoProduto}</td>
                                                <td className="text-sm text-center truncate pl-1 ">{item.CodigoDeBarras}</td>
                                                <td className="text-sm text-left truncate pl-1 ">{item.Descricao}</td>
                                                <td className="text-sm w-auto truncate text-right">{Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(item.PrecoUnitario?.toFixed(2))}</td>
                                                <td className="text-sm w-auto truncate text-right">{Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(item.Quantidade?.toFixed(2))}</td>
                                                <td className="text-sm w-auto truncate text-right">{Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(item.DescontoItem?.toFixed(2))}</td>
                                                <td className="text-sm w-auto truncate text-right">{Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(item.TotalLinha?.toFixed(2))}</td>
                                            </tr>
                                        </>
                                    )
                                })
                            )
                            : (
                                <tr className="text-center">
                                    <td className="p-3 italic" colSpan={7}>
                                        Sem registros
                                    </td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>
            <div className="bg-white-100 flex flex-row justify-between p-2 border-t-2 rounded-md mt-2   bg-gradient-to-r from-slate-200 to-slate-100">
                <p className="text-sm font-semibold ">
                    Total = {props.RegistrosProdutos?.length.toLocaleString('en-US', { minimumFractionDigits: 0 }).replace(',', '.')}
                </p>
                <div className='flex flex-row' >
                    <p className="text-sm font-semibold w-[10.5rem] text-right">
                        Unitário = R$ {Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(somaUnitario)}
                    </p>
                    <p className="text-sm font-semibold w-[10.5rem] text-right">
                        Qtd = {somaQtd.toLocaleString('en-US', { minimumFractionDigits: 0 }).replace(',', '.')}
                    </p>
                    <p className="text-sm font-semibold w-[10.5rem] text-right">
                        Desconto = R$ {Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(somaDesconto)}
                    </p>
                    <p className="text-sm font-semibold w-[10.5rem] text-right">
                        Soma = R$ {Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(somaTotalLinha)}
                    </p>
                </div>
            </div>

            <div className='flex flex-row mt-2'>
                <button
                    onClick={() => handleDownloadPDF()}
                    disabled={isDownloadPDF}
                    className={`${styles.buttonPDF} flex flex-row gap-2 justify-center items-center p-2 rounded-md border border-red-400 hover:bg-red-400 `}
                    style={{
                        opacity: isDownloadPDF ? 0.5 : 1,
                        cursor: isDownloadPDF ? 'not-allowed' : 'pointer'
                    }}
                >
                    <SVGPDF
                        className={`${styles.svgContent}`}
                        color={"red"}
                        height="1.1rem"
                        width="1.1rem"
                    />
                    <div className={`${styles.textContent} text-[0.7rem] font-bold text-black`} >DOWNLOAD DO ARQUIVO</div>

                    {isDownloadPDF ?
                        <div role="status">
                            <svg aria-hidden="true" class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                            </svg>
                            <span class="sr-only">Loading...</span>
                        </div>
                        :
                        null
                    }
                </button>
            </div>
        </div>
    )
}
